import { render, staticRenderFns } from "./GoodLeadsGaugeGraph.vue?vue&type=template&id=d23a86fa&scoped=true&"
import script from "./GoodLeadsGaugeGraph.vue?vue&type=script&lang=ts&"
export * from "./GoodLeadsGaugeGraph.vue?vue&type=script&lang=ts&"
import style0 from "./GoodLeadsGaugeGraph.vue?vue&type=style&index=0&id=d23a86fa&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23a86fa",
  null
  
)

export default component.exports